module.exports = __webpack_public_path__ + "img/img-turfy-umajo-2.48825d86.png";